import { Navigate } from 'react-router-dom';

export default function RedirectWithParams({ to }: { to: string }) {
  return to ? <Navigate to={`/${to}${location.search}`} /> : null;
}
